import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import List from "../../../components/List/List"
import { useGetServicePoints } from "../../../hooks/ServicePoints/useGetServicePoints"
import { servicePointMemory } from "../../../Objects/Memory/Memory"
import { ServicePoints } from "../../../Objects/ServicePoint/ServicePoints"
import defaultStyle from "../../../styles/defaultPageStyle.module.css"
import { ServicePointsPupop } from "./ServicePointsPupop"

export const ServicePointsPage: React.FC = () => {
  const { t } = useTranslation("servicePoints")
  
  const { handleGetServicePoints } = useGetServicePoints()
  
  const handleGetServicePointsRef = useRef(handleGetServicePoints)
  
  const [isPopupOpen, setIsPopupOpen] = useState(false)
 
  const [servicePoint, setServicePoint] = useState<ServicePoints | undefined>()

  useEffect(() => {
    handleGetServicePointsRef.current = handleGetServicePoints
  }, [handleGetServicePoints])

  useEffect(() => {
    void handleGetServicePointsRef.current(() => {})
  }, [])

  const handleClose = () => {
    setIsPopupOpen(false)
    setServicePoint(undefined)
  }

  const handleCreate = () => {
    setServicePoint(undefined)
    setIsPopupOpen(true)
  }

  return (
    <>
      <div className={defaultStyle.containerList}>
        <List
          data={servicePointMemory.getListCards(true)}
          messageCount={t("list:label_service_point_page_message_count")}
          messageEmpty={t("list:label_service_point_page_message_empty")}
          nameFindSearch={t("list:label_service_point_page_place_holder")}
          handleAddButton={handleCreate}
          handleRefreshButton={() => handleGetServicePoints(() => {})}
          handleOnClick={(id) => {
            setServicePoint(servicePointMemory.findById(id) ?? undefined)
            setIsPopupOpen(true)
          }}
        />
      </div>

      {isPopupOpen && (
        <ServicePointsPupop
          servicePointData={servicePoint}
          title={servicePoint ? t("title_popup_edite") : t("title_popup_create")}
          onClose={handleClose}
        />
      )}
    </>
  )
}
